import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField,
    InputAdornment
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const AdminListModal = ({ open, handleClose, title, admins, roles, activeFilter }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredAdmins = admins ? admins.filter(admin =>
        (admin.firstname + ' ' + admin.lastname).toLowerCase().includes(searchTerm.toLowerCase()) ||
        admin.email.toLowerCase().includes(searchTerm.toLowerCase())
    ) : [];

    const getRoleName = (admin) => {
        if (!roles || !admin.adminAccess || admin.adminAccess.length === 0) return '-';

        let relevantAccess = admin.adminAccess;

        if (activeFilter && activeFilter !== 'total') {
            let targetServiceID = null;
            if (activeFilter === 'qos') targetServiceID = 1;
            else if (activeFilter === 'sdoc') targetServiceID = 2;
            else if (activeFilter === 'central') targetServiceID = 3;

            if (targetServiceID) {
                relevantAccess = relevantAccess.filter(access => access.dataportalServiceID === targetServiceID);
            }
        }

        const adminRoles = relevantAccess.map(access => {
            const role = roles.find(r => r.id === access.adminRoleID);
            return role ? role.adminRoleName : null;
        }).filter(name => name !== null);

        if (adminRoles.length === 0) return '-';
        return adminRoles.join(', ');
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <div className="flex justify-between items-center">
                    <span>{title}</span>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="mb-4">
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        placeholder="ค้นหา (ชื่อ, อีเมล)..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
                <TableContainer component={Paper} style={{ maxHeight: '400px' }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>ชื่อ-นามสกุล</b></TableCell>
                                <TableCell><b>อีเมล</b></TableCell>
                                <TableCell><b>สิทธิ์ (Main)</b></TableCell>
                                <TableCell align="center"><b>สถานะ</b></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredAdmins.length > 0 ? (
                                filteredAdmins.map((admin) => (
                                    <TableRow key={admin.id || admin.adminID} hover>
                                        <TableCell>{admin.firstname} {admin.lastname}</TableCell>
                                        <TableCell>{admin.email}</TableCell>
                                        <TableCell>{getRoleName(admin)}</TableCell>
                                        <TableCell align="center">
                                            <span
                                                className={`px-2 py-1 rounded-full text-xs text-white ${admin.adminStatusID === 1 ? 'bg-green-500' : 'bg-red-500'}`}
                                            >
                                                {admin.adminStatusID === 1 ? 'ใช้งาน' : 'ไม่ใช้งาน'}
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={4} align="center" className="py-4 text-gray-500">
                                        ไม่พบข้อมูล
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    ปิด
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminListModal;
